// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Gantt-module__tableContainer___Kzlla {
    position: relative;
    padding: 20px 0;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 16px 32px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    overflow: hidden;
    background: white;
    transform: perspective(1000px) translateZ(0);
    transition: transform 0.3s ease;
}

.Gantt-module__shadedBox___TuxlZ {
    position: absolute;
    background-color: rgba(200, 202, 204, 0.4);
    left: 0;
    height: calc(100% - 70px);
    top: 70px;
    z-index: 1;
    pointer-events: none;
    background: linear-gradient( to right, rgba(200, 202, 204, 0.2), rgba(200, 202, 204, 0.4) );
    box-shadow: inset -2px 0 4px rgba(0, 0, 0, 0.05), inset 2px 0 4px rgba(0, 0, 0, 0.05);
}

.Gantt-module__monthDaysTable____yJBa {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

.Gantt-module__monthCell___vjGJ4 {
    height: 45px;
    transition: background-color 0.2s ease;
}

.Gantt-module__monthDaysTable____yJBa th {
    background-color: #2d2d2d;
    color: white;
    padding: 15px;
    width: calc((100% - 22px) / 12); 
    box-sizing: border-box;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.9em;
    position: relative;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.1);
    border: none;
    transition: transform 0.2s ease;
    margin: 0 1px; 
}

.Gantt-module__monthDaysTable____yJBa thead tr {
    display: flex;
    justify-content: space-between;
    padding: 0 1px; 
}

.Gantt-module__monthDaysTable____yJBa thead th {
    margin: 0 1px; /* gap between headers */
}

.Gantt-module__monthDaysTable____yJBa tbody tr {
    display: flex;
    justify-content: space-between;
    padding: 0 1px;
}

.Gantt-module__monthDaysTable____yJBa tbody td {
    width: calc((100% - 22px) / 12); 
    margin: 0 1px;
}

.Gantt-module__dayRectangle___iPYFC {
    height: 24px;
    position: absolute;
    top: 20%;
    border-radius: 6px;
    text-align: center;
    color: white;
    padding: 4px 8px;
    z-index: 2;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.1);
}

    .Gantt-module__dayRectangle___iPYFC:hover {
        transform: translateY(-2px) scale(1.02);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15), 0 3px 6px rgba(0, 0, 0, 0.1);
    }

.Gantt-module__taskDescription___ZjS5g {
    position: absolute;
    top: 70%;
    text-align: center;
    color: #333;
    font-size: 14px;
    width: 100%;
    white-space: nowrap;
    display: block;
    left: 0;
    z-index: 2;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    transition: transform 0.2s ease;
}

.Gantt-module__dayRectangle___iPYFC.Gantt-module__pastCampaign___N2pad {
    background-color: var(--bmo-primary-color-lavender);
    background: linear-gradient(145deg, var(--bmo-primary-color-lavender), var(--bmo-primary-color-lavender-dark));
}

    .Gantt-module__dayRectangle___iPYFC.Gantt-module__pastCampaign___N2pad:hover {
        background: linear-gradient(145deg, var(--bmo-primary-color-lavender-dark), var(--bmo-primary-color-lavender-darker));
    }

.Gantt-module__dayRectangle___iPYFC.Gantt-module__activeCampaign___OI4Mo {
    border: 2px solid var(--bmo-primary-color-lavender);
    background: repeating-linear-gradient( -35deg, var(--bmo-primary-color-lavender), var(--bmo-primary-color-lavender) 2px, var(--bmo-primary-color-lavender-dark) 4px, var(--bmo-primary-color-lavender-dark) 4px );
}

    .Gantt-module__dayRectangle___iPYFC.Gantt-module__activeCampaign___OI4Mo:hover {
        background: repeating-linear-gradient( -35deg, var(--bmo-primary-color-lavender-dark), var(--bmo-primary-color-lavender-dark) 2px, var(--bmo-primary-color-lavender-darker) 4px, var(--bmo-primary-color-lavender-darker) 4px );
    }

.Gantt-module__dayRectangle___iPYFC.Gantt-module__futureCampaign___MSTB1 {
    background-color: var(--bmo-primary-color-lavender-light);
    color: #333;
    background: linear-gradient(145deg, var(--bmo-primary-color-lavender-light), var(--bmo-primary-color-lavender-light));
}

    .Gantt-module__dayRectangle___iPYFC.Gantt-module__futureCampaign___MSTB1:hover {
        background: linear-gradient(145deg, var(--bmo-primary-color-lavender-dark), var(--bmo-primary-color-lavender-dark));
        color: white;
    }

.Gantt-module__highlighted___WeDbk {
    border: 3px solid #000;
    box-shadow: 0 0 10px rgba(216, 57, 157, 0.4), 0 0 20px rgba(216, 57, 157, 0.2);
    transform: translateZ(4px);
}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/Gantt/Gantt.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;IACf,0EAA0E;IAC1E,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;IAC5C,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,0CAA0C;IAC1C,OAAO;IACP,yBAAyB;IACzB,SAAS;IACT,UAAU;IACV,oBAAoB;IACpB,2FAA2F;IAC3F,qFAAqF;AACzF;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,sEAAsE;IACtE,YAAY;IACZ,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,aAAa,EAAE,wBAAwB;AAC3C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,sEAAsE;AAC1E;;IAEI;QACI,uCAAuC;QACvC,wEAAwE;IAC5E;;AAEJ;IACI,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,OAAO;IACP,UAAU;IACV,0CAA0C;IAC1C,+BAA+B;AACnC;;AAEA;IACI,mDAAmD;IACnD,8GAA8G;AAClH;;IAEI;QACI,qHAAqH;IACzH;;AAEJ;IACI,mDAAmD;IACnD,iNAAiN;AACrN;;IAEI;QACI,+NAA+N;IACnO;;AAEJ;IACI,yDAAyD;IACzD,WAAW;IACX,qHAAqH;AACzH;;IAEI;QACI,mHAAmH;QACnH,YAAY;IAChB;;AAEJ;IACI,sBAAsB;IACtB,8EAA8E;IAC9E,0BAA0B;AAC9B","sourcesContent":[".tableContainer {\n    position: relative;\n    padding: 20px 0;\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 16px 32px rgba(0, 0, 0, 0.05);\n    border-radius: 8px;\n    overflow: hidden;\n    background: white;\n    transform: perspective(1000px) translateZ(0);\n    transition: transform 0.3s ease;\n}\n\n.shadedBox {\n    position: absolute;\n    background-color: rgba(200, 202, 204, 0.4);\n    left: 0;\n    height: calc(100% - 70px);\n    top: 70px;\n    z-index: 1;\n    pointer-events: none;\n    background: linear-gradient( to right, rgba(200, 202, 204, 0.2), rgba(200, 202, 204, 0.4) );\n    box-shadow: inset -2px 0 4px rgba(0, 0, 0, 0.05), inset 2px 0 4px rgba(0, 0, 0, 0.05);\n}\n\n.monthDaysTable {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n}\n\n.monthCell {\n    height: 45px;\n    transition: background-color 0.2s ease;\n}\n\n.monthDaysTable th {\n    background-color: #2d2d2d;\n    color: white;\n    padding: 15px;\n    width: calc((100% - 22px) / 12); \n    box-sizing: border-box;\n    font-weight: 600;\n    text-transform: uppercase;\n    font-size: 0.9em;\n    position: relative;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.1);\n    border: none;\n    transition: transform 0.2s ease;\n    margin: 0 1px; \n}\n\n.monthDaysTable thead tr {\n    display: flex;\n    justify-content: space-between;\n    padding: 0 1px; \n}\n\n.monthDaysTable thead th {\n    margin: 0 1px; /* gap between headers */\n}\n\n.monthDaysTable tbody tr {\n    display: flex;\n    justify-content: space-between;\n    padding: 0 1px;\n}\n\n.monthDaysTable tbody td {\n    width: calc((100% - 22px) / 12); \n    margin: 0 1px;\n}\n\n.dayRectangle {\n    height: 24px;\n    position: absolute;\n    top: 20%;\n    border-radius: 6px;\n    text-align: center;\n    color: white;\n    padding: 4px 8px;\n    z-index: 2;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n    .dayRectangle:hover {\n        transform: translateY(-2px) scale(1.02);\n        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15), 0 3px 6px rgba(0, 0, 0, 0.1);\n    }\n\n.taskDescription {\n    position: absolute;\n    top: 70%;\n    text-align: center;\n    color: #333;\n    font-size: 14px;\n    width: 100%;\n    white-space: nowrap;\n    display: block;\n    left: 0;\n    z-index: 2;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    transition: transform 0.2s ease;\n}\n\n.dayRectangle.pastCampaign {\n    background-color: var(--bmo-primary-color-lavender);\n    background: linear-gradient(145deg, var(--bmo-primary-color-lavender), var(--bmo-primary-color-lavender-dark));\n}\n\n    .dayRectangle.pastCampaign:hover {\n        background: linear-gradient(145deg, var(--bmo-primary-color-lavender-dark), var(--bmo-primary-color-lavender-darker));\n    }\n\n.dayRectangle.activeCampaign {\n    border: 2px solid var(--bmo-primary-color-lavender);\n    background: repeating-linear-gradient( -35deg, var(--bmo-primary-color-lavender), var(--bmo-primary-color-lavender) 2px, var(--bmo-primary-color-lavender-dark) 4px, var(--bmo-primary-color-lavender-dark) 4px );\n}\n\n    .dayRectangle.activeCampaign:hover {\n        background: repeating-linear-gradient( -35deg, var(--bmo-primary-color-lavender-dark), var(--bmo-primary-color-lavender-dark) 2px, var(--bmo-primary-color-lavender-darker) 4px, var(--bmo-primary-color-lavender-darker) 4px );\n    }\n\n.dayRectangle.futureCampaign {\n    background-color: var(--bmo-primary-color-lavender-light);\n    color: #333;\n    background: linear-gradient(145deg, var(--bmo-primary-color-lavender-light), var(--bmo-primary-color-lavender-light));\n}\n\n    .dayRectangle.futureCampaign:hover {\n        background: linear-gradient(145deg, var(--bmo-primary-color-lavender-dark), var(--bmo-primary-color-lavender-dark));\n        color: white;\n    }\n\n.highlighted {\n    border: 3px solid #000;\n    box-shadow: 0 0 10px rgba(216, 57, 157, 0.4), 0 0 20px rgba(216, 57, 157, 0.2);\n    transform: translateZ(4px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `Gantt-module__tableContainer___Kzlla`,
	"shadedBox": `Gantt-module__shadedBox___TuxlZ`,
	"monthDaysTable": `Gantt-module__monthDaysTable____yJBa`,
	"monthCell": `Gantt-module__monthCell___vjGJ4`,
	"dayRectangle": `Gantt-module__dayRectangle___iPYFC`,
	"taskDescription": `Gantt-module__taskDescription___ZjS5g`,
	"pastCampaign": `Gantt-module__pastCampaign___N2pad`,
	"activeCampaign": `Gantt-module__activeCampaign___OI4Mo`,
	"futureCampaign": `Gantt-module__futureCampaign___MSTB1`,
	"highlighted": `Gantt-module__highlighted___WeDbk`
};
export default ___CSS_LOADER_EXPORT___;
